import { Injectable, NgZone } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { ServiceBase } from './base.service';
import { User } from '../models/usuario.model';
import { AuthService } from './auth.service';
import { Data } from '../providers/data';
import { Observable } from 'rxjs';

@Injectable()
export class EstudioService {
  constructor(
    public http: HttpClient,
    public serviceBase: ServiceBase,
    public authService: AuthService,
    public data: Data
  ) {}

  urlService = this.serviceBase.getUrlApi('v1/benefit');

  downloadTicket(ticketId): Observable<any> {
    return this.http.get(`${this.urlService}ticket/${ticketId}`, {
      responseType: 'blob'
    })
    .pipe(
      map((res) => res),
      catchError(this.serviceBase.handleError)
    );
  }


  obtenerTipos(): Observable<any> {
    return this.http.get<any>(`${this.urlService}types`).pipe(
      map((response) => response),
      catchError(this.serviceBase.handleError)
    );
  }

  prestacionDetall(orderId): Observable<any> {
    return this.http.get<any>(`${this.urlService}detail/${orderId}`).pipe(
      map((response) => response),
      catchError(this.serviceBase.handleError)
    );
  }

  sendOrder(benefitId, orderId, files): Observable<any> {
    const url = `${this.urlService}order`;

    const formData: FormData = new FormData();

    formData.append(
      'data',
      JSON.stringify({
        benefitId: benefitId,
        orderId: orderId,
      })
    );

    if (files) {
      for (let i = 0; i < files.length; i++) {
        formData.append(
          files[i].name,
          files[i]
        );
      }
    }

    return this.http
      .post<any>(url, formData)
      .pipe(
        map((response) => response),
        catchError(this.serviceBase.handleError)
      );
  }

  byFiltros(req): Observable<any> {
    const url = `${this.urlService}filter`;
    const body = {
      from: req.desde,
      to: req.hasta,
      documentNumberAffiliateOrder: req.docAfiliado,
      states: req.estado,
      cuit: req.cuit,
      plans: req.planes,
      practices: req.prestaciones,
      companies: req.empresas,
      suppliers: req.prestadores,
    };
    return this.http
      .put<any>(url, body, this.serviceBase.postCommonHeaders())
      .pipe(
        map((response) => response),
        catchError(this.serviceBase.handleError)
      );
  }
}
